import React from "react";
import Page from "../components/layout/Page";

//@ts-ignore
import img1 from "../assets/images/pages/10.jpg";
//@ts-ignore
import img2 from "../assets/images/pages/11.jpg";

export default function Despre() {
  return (
    <Page>
      <div className="page-title">
        <h1>Despre Noi</h1>
      </div>
      <div className="an-section">
        <div className="an-content">
          <p>
            Cu o experiență de peste 20 de ani în domeniul instalațiilor
            electrice și al automatizărilor, suntem o firmă specializată în
            proiectarea și implementarea sistemelor de automatizare pentru case
            inteligente. Ca partener oficial Loxone în Cluj-Napoca, oferim
            soluții complete pentru a crește confortul, siguranța și eficiența
            energetică a locuinței tale.
          </p>
        </div>
      </div>
      <div className="an-section bg-1">
        <div className="an-content flex align-center">
          <div className="an-col w-6">
            <h2>Obiectivul nostru:</h2>
            <p className="mb-0">
              Obiectivul nostru principal este să livrăm sisteme de automatizare
              care funcționează impecabil. Punem accent pe crearea unor locuințe
              cu adevărat inteligente, unde tehnologia operează autonom pentru a
              simplifica activitățile zilnice și a optimiza consumul de resurse,
              fără a avea nevoie de o interacțiune complexă din partea ta.
            </p>
          </div>
          <div className="an-col w-6">
            <img src={img1} className="max-400 center"></img>
          </div>
        </div>
      </div>
      <div className="an-section">
        <div className="an-content align-center flex">
          <div className="an-col w-6 order-2-mobile">
            <img src={img2} className="max-400 center"></img>
            <a className="btn btn-primary show-on-mobile" href="/#contact">
              Programează o vizită în Showroom!
            </a>
          </div>
          <div className="an-col w-6 order-1-mobile">
            <h2>Echipa de specialiști:</h2>
            <p>
              Echipa noastră este compusă din ingineri cu experiență solidă în
              domeniul sistemelor electrice și al automatizarilor. Investim
              constant în pregătirea profesională pentru a fi la curent cu cele
              mai recente inovații tehnologice și pentru a vă oferi cele mai
              bune soluții de pe piață.
            </p>
            <p>
              Cea mai bună metodă de a înțelege funcționalitățile și beneficiile
              unui sistem loxone este să îl testezi. Te așteptăm în ModelHome-ul
              nostru din Cluj-Napoca pentru o prezentare detaliată și pentru a
              discuta despre cum putem aplica această tehnologie în proiectul
              tău.
            </p>
            <a className="btn btn-primary hide-on-mobile" href="/#contact">
              Programează o vizită în Showroom!
            </a>
          </div>
        </div>
      </div>
      <div className="an-section">
        <div className="an-content">
          <iframe
            title="Asempera showroom location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2731.838024187981!2d23.604130113258687!3d46.78779597100615!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47490ea829f89333%3A0x8814021f2fb1c090!2sStr.%20T%C4%83b%C4%83carilor%202%2C%20400394%20Cluj-Napoca!5e0!3m2!1sro!2sro!4v1781082727069!5m2!1sro!2sro"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </Page>
  );
}
